export default __webpack_public_path__ + "static/media/050_brake.hevc.8fc81bc1.mp4";